import { t } from "@lingui/core/macro";

export async function portfolioErrorMessage(error: unknown): Promise<string> {
  if (error instanceof Error && "response" in error && error.response instanceof Response) {
    try {
      const body = await error.response.clone().json();
      if (typeof body.detail === "string" && body.detail) {
        return body.detail;
      }
      if (Array.isArray(body.detail)) {
        const message = body.detail
          .map((issue: { message?: string; msg?: string }) => issue.message ?? issue.msg)
          .filter(Boolean)
          .join("; ");
        if (message) {
          return message;
        }
      }
    } catch {
      /* Fall back to a translated retry message. */
    }
  }
  return t`The portfolio could not be processed. Please try again.`;
}
